// @ts-nocheck
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import Flex from '../components/Flex';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import TestList from './TestList';
import ReportList from './ReportList';
import UserHome from './UserHome';
import ReportResponse from './ReportResponse';
import BrainwaveList from '../components/BrainwaveList';

const UserDashboard = () => {
  return (
    <Container>
      <Navbar />
      <Sidebar />
      <Content>
        <Switch>
          <Route path='/' exact component={UserHome} />
          <Route path='/admin/:userId/test' exact component={TestList} />
          <Route path='/report/:testId' exact component={ReportList} />
          <Route
            path='/report/:testId/:reportId'
            exact
            component={ReportResponse}
          />
          <Route path="/brainwave" component={BrainwaveList} />
          <Route path='*'>
            <Redirect to='/404' />
          </Route>
        </Switch>
      </Content>
    </Container>
  );
};

export default UserDashboard;

const Container = styled(Flex)`
  min-height: 100vh;
`;

const Content = styled(Flex)`
  width: calc(100% - 26rem);
  margin-top: 6rem;
  margin-left: 22rem;
  overflow: auto;
  background-color: ${(props) => props.theme.colors.grey[50]};
`;
